import CONSTANTS from "./CONSTANTS";
import actions from "./actions";
import { toast } from "react-toastify";
import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import constants from "./CONSTANTS";
import mainAxios from "src/settings/axios";
import { map } from "lodash";

export const SERVICES_CCP_MR = "/services/ccp/mr/";
export const COMMON_URL = "/services/ccp/cmm/";
export const SERVICES_CCP_CL = "/services/rcp/cl/cmm/";

export function* getUserAgreement() {
  yield takeLatest(CONSTANTS.GET_USER_AGREEMENT, function* (action) {
    try {
      yield put(actions.setUserAgreement(null));

      const url =
        SERVICES_CCP_MR + "GetAgreementInfo?agreementId=" + action.payload;
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setUserAgreement(data));
    } catch (e) {
      yield put(actions.setUserAgreement({}));
      console.error(e);
    }
  });
}

export function* getUserAgreementById() {
  yield takeLatest(CONSTANTS.GET_USER_AGREEMENT_BY_ID, function* (action) {
    try {
      yield put(actions.setUserAgreementById(null));

      const url = SERVICES_CCP_MR + "GetAllAgreementsByPortalClientUser";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      const data = res.data;

      yield put(actions.setUserAgreementById(data));
    } catch (e) {
      yield put(actions.setUserAgreementById([]));
      console.error(e);
    }
  });
}

function checkNotificationsChanged(oldNotifications, newNotifications) {
  if (!oldNotifications) return false;

  const newIds = new Set(map(newNotifications, (x) => x.notificationId));
  const oldIds = new Set(map(oldNotifications, (x) => x.notificationId));

  return newIds.size > oldIds.size;
}

export function* notificationRequest() {
  yield takeLatest(constants.GET_NOTIFICATIONS, function* (action) {
    const calledFromHub = action.payload;
    const currentNotifications = yield select(
      (state) => state.common.notifications
    );
    try {
      // if called from hub dont show loading
      if (!calledFromHub) {
        yield put(actions.setNotifications(null));
      }

      const getAllNotifications = false;
      const url = `/services/notification/GetNotifications/${getAllNotifications}`;
      const res = yield mainAxios.get(url).then((r) => r.data);
      const data = res.data;

      const error = {
        errorCode: res.errorCode,
        errorMessage: res.errorMessage,
      };

      if (!res.success) throw error;

      const notificationsChanged = yield checkNotificationsChanged(
        currentNotifications,
        data
      );
      if (notificationsChanged) {
        const toastId = "new-notifications-success";
        toast("ახალი შეტყობინება", { toastId });
      }

      yield put(actions.setNotifications(data));
    } catch (e) {
      console.error(e);
      const toastId = "load-notifications-error";
      toast("შეტყობინებების ჩატვირტვა ვერ მოხერხდა", { toastId });
      // if called from hub dont empty on error
      if (!calledFromHub) {
        yield put(actions.setNotifications([]));
      }
    }
  });
}

export function* allNotificationsRequest() {
  yield takeLatest(constants.GET_ALL_NOTIFICATIONS, function* (action) {
    const calledFromHub = action.payload;
    try {
      // if called from hub dont show loading
      if (!calledFromHub) {
        yield put(actions.setAllNotifications(null));
      }

      const getAllNotifications = true;
      const url = `/services/notification/GetNotifications/${getAllNotifications}`;
      const res = yield mainAxios.get(url).then((r) => r.data);
      const data = res.data;

      const error = {
        errorCode: res.errorCode,
        errorMessage: res.errorMessage,
      };

      if (!res.success) throw error;

      yield put(actions.setAllNotifications(data));
    } catch (e) {
      console.log(e);
      const toastId = "load-all-notifications-error";
      toast("შეტყობინებების ჩატვირტვა ვერ მოხერხდა", { toastId });
      // if called from hub dont empty on error
      if (!calledFromHub) {
        yield put(actions.setAllNotifications([]));
      }
    }
  });
}

export function* readNotification() {
  yield takeLatest(constants.READ_NOTIFICATION, function* (action) {
    const { notificationId, callbackActions } = action.payload;

    try {
      const url = `/services/notification/MarkAsReadNotification/${notificationId}`;
      const res = yield mainAxios.put(url).then((r) => r.data);

      const error = {
        errorCode: res.errorCode,
        errorMessage: res.errorMessage,
      };

      if (!res.success) throw error;

      // MOCK
      // yield delay(1000);
      // yield put(actions.setNotifications([]))

      // if successfuly read notification
      // dispatch callback actions
      // request new notifications
      yield all(callbackActions.map((action) => put(action)));
      yield put(actions.getNotifications());
    } catch (e) {
      console.log(e);
      const toastId = "read-notifications-error";
      toast("შეტყობინების წაკითხვა ვერ მოხერხდა", { toastId });
    }
  });
}

function* receiveNotifications() {
  yield takeLatest(constants.RECEIVE_NOTIFICATIONS, function* (action) {
    yield put(actions.getNotifications(true));
    const allNotificationsOpen = yield select(
      (state) => state.common.allNotificationsOpen
    );
    if (allNotificationsOpen) yield put(actions.getAllNotifications(true));
  });
}

export function* getDocTitles() {
  yield takeLatest(CONSTANTS.GET_LEGAL_INFO_DOC_TITLES, function* (action) {
    try {
      yield put(actions.setDocTitles(null));

      const url =
        SERVICES_CCP_CL + "GetDocTitles?requestDocTypeId=" + action.payload;
      const res = yield window.mainAxios.get(url).then((x) => x.data);

      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      yield put(actions.setDocTitles(res.data));
    } catch (e) {
      yield put(actions.setDocTitles([]));
    }
  });
}

export function* getDownloadDocument() {
  yield takeLatest(CONSTANTS.GET_DOWNLOAD_DOCUMENT, function* (action) {
    try {
      if (action.payload.hasLoading) {
        yield put(actions.setDownloadDocumentLoading(true));
      }
      const url = `/services/common/GetFileData?oid=${action.payload.oid}`;
      // yield blobDownload(url);
      const res = yield window.mainAxios.get(url).then((x) => x.data);

      if (!res.fileContents)
        // eslint-disable-next-line no-throw-literal
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      yield put(actions.setDownloadDocumentLoading(false));
      yield openFileInSameTab(res);
    } catch (e) {
      const lang = yield select((state) => state.common.lang);
      toast.error(
        lang === "ge" ? "მოქმედება ვერ განხორციელდა" : "couldn't download file"
      );
    }
  });
}

// Exporting all sagas as 1 root saga
export default function* rootSaga() {
  yield all([
    fork(notificationRequest),
    fork(readNotification),
    fork(allNotificationsRequest),
    fork(receiveNotifications),
    fork(getUserAgreement),
    fork(getUserAgreementById),
    fork(getDownloadDocument),
    fork(getDocTitles),
  ]);
}

function openFileInSameTab(res) {
  const fileContents = res?.fileContents;
  const fileDownloadName = res?.fileDownloadName || "document.pdf";

  // Decode the base64-encoded file contents
  const byteCharacters = window.atob(fileContents);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const pdfBlob = new Blob([byteArray], { type: "application/pdf" });

  // Create a URL for the PDF Blob
  const pdfBlobUrl = URL.createObjectURL(pdfBlob);

  // Check if the user is on a mobile device
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  if (isMobile) {
    // Directly create a download
    const link = document.createElement("a");
    link.href = pdfBlobUrl;
    link.download = fileDownloadName;

    // Use a timeout to avoid blocking DOM updates
    setTimeout(() => {
      link.click(); // Trigger the download
      URL.revokeObjectURL(pdfBlobUrl); // Clean up the object URL
    }, 0);
  } else {
    // If not mobile, open the PDF in an iframe
    const iframe = document.createElement("iframe");
    iframe.src = pdfBlobUrl;
    iframe.style.width = "100%"; // Ensure it fits the screen
    iframe.style.height = "100%"; // Full viewport height
    iframe.style.border = "none";
    document.body.innerHTML = ""; // Clear current content
    document.body.appendChild(iframe); // Append the iframe to the body
  }
}
